/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ToggleInsurance/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaToggle from 'DesignSystem/TysiaToggle/index'
import TysiaToggleButton from 'DesignSystem/TysiaToggle/TysiaToggleButton/index'



/** @type {import('Simple/types.js').View} */
export default function ToggleInsurance({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/Insurances/ToggleInsurance"
  
}) {
let paymentPlanInsurancesValueData = fromData.useDataFormat({ viewPath,
context: 'payment_plan',
path: 'insurances',
format: fromFormat.isNotEmptyList,
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let onClick = fromHelpers.useOnToggle({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<TysiaToggle
  viewPath={`${viewPath}/TysiaToggle`}
 marginTop={0}
 marginLeft={dtSpaceXs}
 data="payment_plan.insurances"
 format="/Data/format.js isNotEmptyList"
 value={paymentPlanInsurancesValueData}
 onClick={onClick}
>
{childProps => (
<TysiaToggleButton
{...childProps}
  viewPath={`${viewPath}/TysiaToggleButton`}
 paddingTop={0}
 paddingBottom={0}
 paddingRight={0}
 paddingLeft={0}
/>
)}
</TysiaToggle>
{children}
</React.Fragment>)
}